import { useState } from "react";
import { X, MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";

const WhatsAppFAB = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Popup Card */}
      <div
        className={`transition-all duration-300 ${
          isOpen
            ? "opacity-100 translate-y-0 scale-100 pointer-events-auto"
            : "opacity-0 translate-y-4 scale-95 pointer-events-none"
        } fixed sm:absolute bottom-[80px] sm:bottom-[76px] left-0 sm:left-auto right-0 sm:right-0 w-full sm:w-[300px] rounded-t-xl sm:rounded-xl bg-white shadow-xl overflow-hidden origin-bottom sm:origin-bottom-right`}
      >
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-3 right-3 p-1.5 rounded-full hover:bg-muted transition-colors z-10"
          aria-label={t("chat.close")}
        >
          <X className="w-4 h-4 text-muted-foreground" />
        </button>

        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              NT
            </div>
            <div>
              <p className="font-semibold text-foreground text-sm">NordicThai Translate</p>
              <p className="text-xs text-muted-foreground flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-[#25D366] inline-block" />
                {t("chat.online")}
              </p>
            </div>
          </div>

          <p className="text-sm text-muted-foreground leading-relaxed mb-5">
            {t("chat.greeting")}
          </p>

          <div className="flex flex-col gap-2">
            <a
              href="https://wa.me/66821858187"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 w-full bg-[#25D366] text-white rounded-lg px-4 min-h-[48px] py-3 text-sm font-semibold hover:bg-[#1da851] transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              {t("chat.start")}
            </a>
            <a
              href="tel:+66821858187"
              className="flex items-center justify-center gap-2 w-full border border-border text-foreground rounded-lg px-4 min-h-[48px] py-3 text-sm font-semibold hover:bg-muted transition-colors"
            >
              <Phone className="w-4 h-4" />
              {t("chat.call")}
            </a>
          </div>
        </div>
      </div>

      {/* FAB Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t("chat.button")}
        className="relative flex items-center justify-center w-[60px] h-[60px] rounded-full bg-[#25D366] text-white shadow-[0_4px_14px_rgba(0,0,0,0.25)] hover:scale-110 transition-transform duration-200"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-[fab-ping_5s_ease-out_infinite] opacity-0" />

        {isOpen ? (
          <X className="w-6 h-6 relative z-10" />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="white"
            className="w-8 h-8 relative z-10"
          >
            <path d="M16.004 0C7.165 0 .002 7.159.002 15.995c0 2.82.737 5.573 2.14 7.998L.012 32l8.244-2.107A15.95 15.95 0 0 0 16.004 32C24.838 32 32 24.836 32 15.995 32 7.159 24.838 0 16.004 0Zm0 29.39a13.36 13.36 0 0 1-7.215-2.1l-.518-.307-5.362 1.37 1.394-5.234-.337-.535A13.32 13.32 0 0 1 2.61 15.995c0-7.39 6.008-13.395 13.394-13.395 7.39 0 13.396 6.006 13.396 13.395 0 7.394-6.007 13.395-13.396 13.395Zm7.342-10.03c-.402-.202-2.382-1.175-2.75-1.31-.37-.134-.639-.201-.908.202-.268.403-1.041 1.31-1.276 1.579-.235.268-.47.302-.872.1-.402-.2-1.698-.625-3.234-1.995-1.195-1.066-2.001-2.383-2.236-2.785-.235-.403-.025-.62.177-.82.181-.181.402-.47.604-.706.201-.235.268-.403.402-.672.134-.268.067-.503-.034-.705-.1-.201-.908-2.187-1.243-2.994-.328-.786-.66-.68-.908-.692l-.773-.013c-.268 0-.705.1-1.074.503-.369.402-1.41 1.378-1.41 3.36 0 1.983 1.444 3.899 1.645 4.167.202.268 2.84 4.335 6.882 6.078.962.415 1.713.663 2.298.849.966.307 1.845.264 2.54.16.774-.116 2.382-.974 2.718-1.914.336-.94.336-1.746.235-1.914-.1-.168-.369-.268-.772-.47Z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppFAB;
